<div class="main-content">
  <div class="container-fluid">

    <div class="row">

      <div class="row graphsContainer">

        <div class="row w-100 ml-0" *ngIf="livesAppLicence">
          <div class="dashboardCardBig">
            <div class="kpiContainer horizontalLayout">
              <h5 class="dashboardTitle">
                Datos Lives HR
              </h5>
              <div _ngcontent-vwv-c729="" class="kpiContent row mt-3">
                <div class="col-8">
                  <app-dropdown-formularios dataSize="7" placeHolder="Empresas" [required]="true"
                    [dropdownType]="'Companies'" [(ngModel)]="selectedCompany"
                    (selectedValueChange)="companySelectedChanged($event)" [detailedData]="true">
                  </app-dropdown-formularios>
                </div>
                <div class="col-2">
                  <app-year-selector dataSize="7" placeHolder="Ejercicio" [(selectedValue)]="selectedLivesYear"
                    [required]="true">
                  </app-year-selector>
                </div>
                <!-- Botón de búsqueda -->
                <div class="col-2">
                  <button mat-raised-button class="btn-primary" [disabled]="!selectedYear || !selectedCompany"
                    (click)="loadRequestsData()">

                    <div *ngIf="isLoadingRequests" class="custom-loader-container">
                      <span class="custom-loader"></span>
                    </div>
                    <mat-icon *ngIf="!isLoadingRequests">refresh</mat-icon>

                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="fluidContent dashboardWidgetContainer" *ngIf="livesAppLicence">

          <div class="dashboardCardRegular">
            <div class="kpiContainer verticalLayout">
              <div class="kpiHeader alignVerticalMiddle ng-star-inserted">
                <div class="kpiTitle ng-star-inserted"> % Tipos Solicitudes </div>
                <!---->
                <div class="colAvailable"></div>
                <div class="kpiFilterDescription colAuto ng-star-inserted"> Anual </div>
                <!---->
              </div>
              <div class="kpiContent rowAvailable verticalLayout">
                <div class="fullHeight" _nghost-qfl-c22="">
                  <div style="height: 100%;" class="verticalLayout">
                    <div id="chart-demo">
                      <dx-pie-chart #pie palette="bright" [dataSource]="datosTiposSolicitudes"
                        resolveLabelOverlapping="hide">
                        <dxo-margin [bottom]="20"></dxo-margin>
                        <dxo-size [width]="340"></dxo-size>
                        <dxo-export [enabled]="false"></dxo-export>
                        <dxo-legend orientation="horizontal" itemTextPosition="right" horizontalAlignment="center"
                          verticalAlignment="bottom" [columnCount]="4"></dxo-legend>
                        <dxi-series argumentField="TipoSolicitud" valueField="Porcentaje">
                          <dxo-label [visible]="true" [customizeText]="customizeLabel">
                            <dxo-connector [visible]="true" [width]="0.5"></dxo-connector>
                          </dxo-label>
                        </dxi-series>
                      </dx-pie-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dashboardCardBig" *ngIf="livesAppLicence">

          <div class="kpiContainer verticalLayout">
            <!---->
            <div class="kpiHeader alignVerticalMiddle ng-star-inserted">
              <div class="kpiTitle ng-star-inserted"> Solicitudes Pendientes vs Gestionadas </div>
              <!---->
              <div class="colAvailable"></div>
              <div class="kpiFilterDescription colAuto ng-star-inserted"> Anual </div>
              <!---->
            </div>
            <!---->
            <div class="kpiContent rowAvailable verticalLayout ng-star-inserted">

              <div class="rowAvailable verticalLayout ng-star-inserted" style="overflow-y: auto;">

                <dx-chart id="chart" [dataSource]="datosSolicitudesMesVS">
                  <!-- [visualRange]="chart_visualRange" -->
                  <dxi-value-axis [maxValueMargin]="0.01" tickInterval="1">
                  </dxi-value-axis>
                  <dxi-series valueField="TotalPendiente" name="Total pendientes"></dxi-series>
                  <dxi-series valueField="TotalGestionadas" name="Total gestionadas"></dxi-series>


                  <dxo-common-series-settings argumentField="NombreMes" type="bar" hoverMode="allArgumentPoints"
                    selectionMode="allArgumentPoints">
                    <dxo-label [visible]="false" [format]="{
                      type: 'fixedPoint',
                      precision: '0'
                    }">
                    </dxo-label>
                  </dxo-common-series-settings>
                  <dxo-legend verticalAlignment="bottom" horizontalAlignment="center">
                  </dxo-legend>
                  <!-- <dxo-size [width]="340"></dxo-size> -->
                  <dxo-export [enabled]="false"></dxo-export>
                </dx-chart>

              </div>
              <!---->

            </div>
            <!---->
            <!---->
            <!---->
            <!---->
          </div>
        </div>

        <div class="row w-100 ml-0" *ngIf="hostelLicence" [ngClass]="{'mt-3': livesAppLicence}">
          <div class="dashboardCardBig">
            <div class="kpiContainer horizontalLayout">
              <h5 class="dashboardTitle">
                Datos Hostel HR
              </h5>
              <div _ngcontent-vwv-c729="" class="kpiContent row mt-3">
                <div class="col-8">
                  <app-company-selector dataSize="7" placeHolder="Empresas" [(ngModel)]="selectedCompany"
                    [required]="true" [onlyConfigured]="true"></app-company-selector>
                </div>
                <div class="col-2">
                  <app-year-selector dataSize="7" placeHolder="Ejercicio" [(selectedValue)]="selectedYear"
                    [required]="true">
                  </app-year-selector>
                </div>
                <!-- Botón de búsqueda -->
                <div class="col-2">
                  <button mat-raised-button class="btn-primary" [disabled]="!selectedYear || !selectedCompany"
                    (click)="loadKpiData()"><mat-icon>refresh</mat-icon></button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="fluidContent dashboardWidgetContainer" *ngIf="hostelLicence">
          <div class="dashboardCardRegular">
            <div class="kpiContainer verticalLayout">
              <div class="kpiHeader alignVerticalMiddle ng-star-inserted">
                <div class="kpiTitle ng-star-inserted"> % Pago Bolsa </div>
                <!---->
                <div class="colAvailable"></div>
                <div class="kpiFilterDescription colAuto ng-star-inserted"> Anual </div>
                <!---->
              </div>
              <div class="kpiContent rowAvailable verticalLayout">
                <div class="fullHeight" _nghost-qfl-c22="">
                  <div style="height: 100%;" class="verticalLayout">
                    <div id="chart-demo">
                      <dx-pie-chart #pie palette="bright" [dataSource]="datosKpiBolsaVacaciones"
                        resolveLabelOverlapping="hide">
                        <dxo-margin [bottom]="20"></dxo-margin>
                        <dxo-size [width]="340"></dxo-size>
                        <dxo-export [enabled]="false"></dxo-export>
                        <dxo-legend orientation="horizontal" itemTextPosition="right" horizontalAlignment="center"
                          verticalAlignment="bottom" [columnCount]="4"></dxo-legend>
                        <dxi-series argumentField="NombreMes" valueField="Porcentaje">
                          <dxo-label [visible]="true" [customizeText]="customizeLabel">
                            <dxo-connector [visible]="true" [width]="0.5"></dxo-connector>
                          </dxo-label>
                        </dxi-series>
                      </dx-pie-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dashboardCardBig" *ngIf="hostelLicence">

          <div class="kpiContainer verticalLayout">
            <!---->
            <div class="kpiHeader alignVerticalMiddle ng-star-inserted">
              <div class="kpiTitle ng-star-inserted"> Importe pagado bolsa </div>
              <!---->
              <div class="colAvailable"></div>
              <div class="kpiFilterDescription colAuto ng-star-inserted"> Anual </div>
              <!---->
            </div>
            <!---->
            <div class="kpiContent rowAvailable verticalLayout ng-star-inserted">

              <div class="rowAvailable verticalLayout ng-star-inserted" style="overflow-y: auto;">

                <dx-chart id="chart" [dataSource]="datosKpiBolsaVacaciones">
                  <!-- [visualRange]="chart_visualRange" -->
                  <dxi-value-axis [maxValueMargin]="0.01">
                  </dxi-value-axis>
                  <dxi-series valueField="TotalBolsaVacaciones" name="Total bolsa vacaciones"></dxi-series>
                  <dxi-series valueField="TotalPagado" name="Total pagado"></dxi-series>

                  <dxo-common-series-settings argumentField="NombreMes" type="bar" hoverMode="allArgumentPoints"
                    selectionMode="allArgumentPoints">
                    <dxo-label [visible]="false" [format]="{
                      type: 'fixedPoint',
                      precision: '0'
                    }">
                    </dxo-label>
                  </dxo-common-series-settings>
                  <dxo-legend verticalAlignment="bottom" horizontalAlignment="center">
                  </dxo-legend>
                  <!-- <dxo-size [width]="340"></dxo-size> -->
                  <dxo-export [enabled]="false"></dxo-export>
                </dx-chart>

              </div>
              <!---->

            </div>
            <!---->
            <!---->
            <!---->
            <!---->
          </div>
        </div>

        <div class="row w-100 ml-0" *ngIf="attendanceLicence && (!livesAppLicence && !hostelLicence)"
          style="cursor: pointer;" (click)="navigate('https://liveshr.com/')">
          <img src="https://liveshr.com/wp-content/uploads/2024/12/banner-LivesHR_Portal-del-empleado.png"
            alt="Banner Marcajes" width="1100">

        </div>


      </div>


      <div class="fluidContent dashboardWidgetContainer topSpacer">
        <div class="dashboardCardRegular">
          <div class="kpiContainer verticalLayout">
            <div class="kpiContent rowAvailable verticalLayout">
              <div class="fullHeight" _nghost-qfl-c22="">
                <div style="height: 100%;" class="verticalLayout">
                  <div class="rowAvailable firstHyperlinkIconColor hyperlinkPaddingContent"
                    (click)="navigate('https://academy.linksoluciones.com/')">
                    <div class="alignMiddle hyperlinkIconContainer">
                      <div class="baseIcon">
                        <fa-icon icon="graduation-cap"></fa-icon>
                      </div>
                    </div>
                    <div class="alignMiddle hyperlinkTitle">
                      Link Academy
                    </div>
                    <div class="hyperlinkSubText">
                      Plataforma que te permite acceder a un amplio catálogo formativo para aprender a utilizar de forma
                      sencilla nuestras soluciones
                    </div>
                  </div>
                  <div class="hyperlinkSeparator" *ngIf="hostelLicence"></div>
                  <div class="rowAvailable secondHyperlinkIconColor hyperlinkPaddingContent"
                    (click)="navigate('https://hostelhr.com/novedades/Novedades%20y%20Actualizaciones%20HostelHR.pdf')"
                    *ngIf="hostelLicence">
                    <div class="alignMiddle hyperlinkIconContainer">
                      <div class="baseIcon">
                        <fa-icon icon="newspaper"></fa-icon>
                      </div>
                    </div>

                    <div class="alignMiddle hyperlinkTitle">
                      Novedades
                    </div>
                    <div class="hyperlinkSubText">
                      Consulta todas las novedades de HostelHR
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="hostelLicence">
      <div class="fluidContent dashboardWidgetContainer">
        <div class="dashboardCardRegular">
          <div class="kpiContainer verticalLayout">
            <!---->
            <div class="kpiHeader alignVerticalMiddle ng-star-inserted">
              <div class="kpiTitle ng-star-inserted"> Detalle bolsa vacaciones </div>
              <!---->
              <div class="colAvailable"></div>
              <div class="kpiFilterDescription colAuto ng-star-inserted"> Anual </div>
              <!---->
            </div>
            <!---->
            <div class="kpiContent rowAvailable verticalLayout">
              <div class="fullHeight" _nghost-qfl-c22="">
                <div style="height: 100%;" class="verticalLayout">
                  <div style="width: 100%;" class="ng-star-inserted">
                    <div class="topCardListContainer verticalLayout">
                      <div class="companySelectorGrid verticalLayout">
                        <li>
                          <div class="topCardList">
                            <div class="topCardListText truncateText">
                              <div class="topCardListTitle truncateText">Total</div>
                              <div class="topCardListSubtitle truncateText">{{totalBV |
                                currency:'EUR':'symbol-narrow':'1.2-2'}}</div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="topCardList">
                            <div class="topCardListText truncateText">
                              <div class="topCardListTitle truncateText">Pagado</div>
                              <div class="topCardListSubtitle truncateText">{{pagadoBV |
                                currency:'EUR':'symbol-narrow':'1.2-2'}}</div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="topCardList">
                            <div class="topCardListText truncateText">
                              <div class="topCardListTitle truncateText">Pendiente</div>
                              <div class="topCardListSubtitle truncateText">{{pendienteBV |
                                currency:'EUR':'symbol-narrow':'1.2-2'}}</div>
                            </div>
                          </div>
                        </li>
                        <div class="hyperlinkSeparator"></div>
                        <li>
                          <div class="topCardList">
                            <div class="topCardListText truncateText">
                              <div class="topCardListTitle truncateText">% Pagado</div>
                              <div class="topCardListSubtitle truncateText">{{porcentajePagado | number : '1.2-2'}} %
                              </div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="topCardList">
                            <div class="topCardListText truncateText">
                              <div class="topCardListTitle truncateText">% Pendiente</div>
                              <div class="topCardListSubtitle truncateText">{{porcentajePendiente | number : '1.2-2'}} %
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fluidContent dashboardWidgetContainer">
        <div class="dashboardCardRegular">
          <div class="kpiContainer verticalLayout">
            <!---->
            <div class="kpiHeader alignVerticalMiddle ng-star-inserted">
              <div class="kpiTitle ng-star-inserted"> Vacaciones </div>
              <!---->
              <div class="colAvailable"></div>
              <div class="kpiFilterDescription colAuto ng-star-inserted"> Anual </div>
              <!---->
            </div>
            <!---->
            <div class="kpiContent rowAvailable verticalLayout">
              <div class="fullHeight" _nghost-qfl-c22="">
                <div style="height: 100%;" class="verticalLayout">
                  <div style="width: 100%;" class="ng-star-inserted">
                    <div class="topCardListContainer verticalLayout">
                      <div class="companySelectorGrid verticalLayout">
                        <li>
                          <div class="topCardList">
                            <div class="topCardListText truncateText">
                              <div class="topCardListTitle truncateText">Total días</div>
                              <div class="topCardListSubtitle truncateText">{{datosKpiDiasVacaciones &&
                                datosKpiDiasVacaciones.Total}}</div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="topCardList">
                            <div class="topCardListText truncateText">
                              <div class="topCardListTitle truncateText">Nº Empleados</div>
                              <div class="topCardListSubtitle truncateText">{{datosKpiDiasVacaciones &&
                                datosKpiDiasVacaciones.Empleados}}</div>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div class="topCardList">
                            <div class="topCardListText truncateText">
                              <div class="topCardListTitle truncateText">Promedio días</div>
                              <div class="topCardListSubtitle truncateText">{{datosKpiDiasVacaciones &&
                                datosKpiDiasVacaciones.Promedio | number :
                                '1.2-2'}}</div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fluidContent dashboardWidgetContainer">
        <div class="dashboardCardRegular">
          <div class="kpiContainer verticalLayout">
            <!---->
            <div class="kpiHeader alignVerticalMiddle ng-star-inserted">
              <div class="kpiTitle ng-star-inserted"> Sustituciones </div>
              <!---->
              <div class="colAvailable"></div>
              <div class="kpiFilterDescription colAuto ng-star-inserted"> Anual </div>
              <!---->
            </div>
            <!---->
            <div class="kpiContent rowAvailable verticalLayout">
              <div class="fullHeight" _nghost-qfl-c22="">
                <div style="height: 100%;" class="verticalLayout">
                  <div style="width: 100%;" class="ng-star-inserted">
                    <div class="topCardListContainer verticalLayout">
                      <div class="companySelectorGrid verticalLayout">
                        <li>
                          <div class="topCardList">
                            <div class="topCardListText truncateText">
                              <div class="topCardListTitle truncateText">Empleados en IT</div>
                              <div class="topCardListSubtitle truncateText">{{datosKpiSustituciones &&
                                datosKpiSustituciones.EmpleadosEnIT}}
                              </div>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="topCardList">
                            <div class="topCardListText truncateText">
                              <div class="topCardListTitle truncateText">Sustituidos</div>
                              <div class="topCardListSubtitle truncateText">{{datosKpiSustituciones &&
                                datosKpiSustituciones.Sustituciones}}
                              </div>
                            </div>
                          </div>
                        </li>

                        <li>
                          <div class="topCardList">
                            <div class="topCardListText truncateText">
                              <div class="topCardListTitle truncateText">Ratio</div>
                              <div class="topCardListSubtitle truncateText">{{datosKpiSustituciones &&
                                datosKpiSustituciones.Ratio | number :
                                '1.2-2'}} %</div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>

<!-- <app-first-step-video [modalId]="modalId" [videoId]="428144647"></app-first-step-video> -->